<div class="row d-flex align-items-center" *ngIf="showConnectedAs">
    <p class="text-center col-12 m-0">
        <span
            [innerHTML]="
                'accountant.connected-as'
                    | translate: { user: usernameConnectedAs }
            "
        ></span>
        (<a (click)="logout()"
            ><u class="logout">{{ 'accountant.logout' | translate }}</u></a
        >)
    </p>
</div>
